import { render } from "./AllocationDetailsView.vue?vue&type=template&id=453f0f7a&scoped=true"
import script from "./AllocationDetailsView.vue?vue&type=script&lang=js"
export * from "./AllocationDetailsView.vue?vue&type=script&lang=js"

import "./AllocationDetailsView.vue?vue&type=style&index=0&id=453f0f7a&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-453f0f7a"

export default script